export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7724.bd0b60be.jpg";